import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const EMBED_PATTERNS = [{
  pattern: new RegExp('^https:\\/\\/web.microsoftstream.com\\/embed\\/.*$')
}, {
  pattern: new RegExp("^https:\\/\\/.*\\.tekioncloud.com\\/superset\\/explore\\/.*$")
}, {
  pattern: new RegExp("^https:\\/\\/.*vimeo.com\\/.*$")
}, {
  pattern: new RegExp("^https:\\/\\/.*youtube.com\\/embed\\/.*$")
}];
export const isEmbedUrl = function (url) {
  let embedPatterns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const RESULT_PATTERNS = [...embedPatterns, ...EMBED_PATTERNS];
  const MATCHED_PATTERN = RESULT_PATTERNS.find(resultPattern => !!url.match(resultPattern.pattern));
  return _objectSpread({
    canEmbed: !!MATCHED_PATTERN
  }, MATCHED_PATTERN);
};